<template>
  <DialogModal :is-destructive-alert="false" @secondary="$emit('cancel')" @primary="$emit('exit')">
    <span slot="header" v-localize="HEADER_TEXT_KEY" />
    <span slot="body" v-localize="BODY_TEXT_KEY" />
    <span slot="secondary-button-text" v-localize="SECONDARY_BUTTON_TEXT_KEY" />
    <span slot="primary-button-text" v-localize="PRIMARY_BUTTON_TEXT_KEY" />
  </DialogModal>
</template>

<script>
import DialogModal from '@/components/AvatarBuilderUI/Dialogs/DialogModal.vue';
import { LocalizationDirective } from '@/directives/LocalizationDirective';
import { ExitDialogTypeEnum } from '@/enum/exit_dialog_type';

export default {
  name: 'ExitDialog',
  components: {
    DialogModal,
  },
  created: function() {
    this.HEADER_TEXT_KEY =
      this.$store.getters.exitDialogType == ExitDialogTypeEnum.UNLOCKABLE
        ? 'UnlockableExitDialogTitle'
        : 'CategoryExitDialogTitle';
    this.BODY_TEXT_KEY =
      this.$store.getters.exitDialogType == ExitDialogTypeEnum.UNLOCKABLE
        ? 'UnlockableExitDialogMessage'
        : 'CategoryExitDialogMessage';
    this.SECONDARY_BUTTON_TEXT_KEY = 'Cancel';
    this.PRIMARY_BUTTON_TEXT_KEY = 'Exit';
  },
  directives: {
    LocalizationDirective,
  },
};
</script>
